import { combineEpics } from 'redux-observable';
import appUsers from './appUsers';
import attributes from './attributes';
import emailAddress from './emailAddress';
import emails from './emails';
import profile from './profile';
import profileOptions from './profileOptions';
import alerts from './alerts';
import notifications from './notifications';
import hubUsers from './hubUsers';
import avatar from './avatar';
import unrecoverableErrors from './unrecoverableErrors';
import twoFactorAuth from './twoFactorAuth';
import sendAsEmails from '../send-as-emails/epics';
import navConfig from './navConfig';
import saveStagedChangesEpic from './saveStagedChangesEpic';
import clearStagedChangesEpic from './clearStagedChangesEpic';
import securityPhoneNumber from './security/securityPhoneNumber';
import isRestrictedImpersonatee from './isRestrictedImpersonatee';
export default combineEpics(appUsers, attributes, isRestrictedImpersonatee, emailAddress, emails, unrecoverableErrors, profileOptions, hubUsers, avatar, alerts, notifications, profile, securityPhoneNumber, twoFactorAuth, sendAsEmails, navConfig, saveStagedChangesEpic, clearStagedChangesEpic);